import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campPlReorder: FaireAdCampaignEntity = {
  token: "camp_pl_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_pennyline",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 1000,
  startedRunningAt: "2026-02-12",
  segmentMetrics: {
    numReorderConversions: 126,
    salesDollars: 32053,
    totalAdsSpendDollars: 2788,
    returnOnAdSpend: 11.5,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-25T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
